import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {DoctorService} from '../../_services/doctor.service';
import {UserService} from '../../_services/user.service';
import {ScheduleService} from "../../_services/schedule.service";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import jwt_decode from 'jwt-decode';
declare const fbq: any;
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  addDocForm: FormGroup;
  submitted = false;
  buttonenable = false;
  returnUrl: string;
  selectedfile: File = null;
  selectedfile1:  Array<File> = [];
  userdetaild: string;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';

  users: [];
  msgcode: string;

  isShown: boolean = false ; // hidden by default
  isShown1: boolean = false ; // hidden by default

  degree: any[] = [];
  languages: any[] = [];
  speciality: any[] = [];
  session_mode: any[] = [];
  ShowFilter = true;
  limitSelection = false;
  dropdownSettings: any = {};
  dropdownSettings1: any = {};


  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private userservice: UserService, private doctorservice: DoctorService, private scheduleservice: ScheduleService, private spinnerService: Ng4LoadingSpinnerService, private ng2ImgMax: Ng2ImgMaxService) { }

  ngOnInit() {

    if (this.authenicationService.currentUserValue) {
      this.router.navigate(['/']);
    }

   // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/selectpicker.js');


    this.addDocForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      users_email: ['', [Validators.required, Validators.email]],
      users_password: ['', [Validators.required, Validators.minLength(6)]],
      photo: [''],
      users_code: ['+91'],
      users_mobile: ['', [Validators.required]],
      users_city: ['', [Validators.required]],
      //users_status: ['false', [Validators.required]],
      degree: ['', [Validators.required]],
      mental_health_prof: ['', [Validators.required]],
      experience: ['', [Validators.required]],
      language: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      about: ['', [Validators.required]],
      speciality: ['', [Validators.required]],
      //certificates: ['',[Validators.required]],
      certificates: [''],
      session_mode: ['', [Validators.required]],
      own_space: ['N/A', [Validators.required]],
      space_address: ['N/A', [Validators.required]]
    });

    this.degree = [
      { item_id: 'M.Phil', item_text: 'M.Phil' },
      { item_id: 'MA/Msc', item_text: 'MA/Msc' },
      { item_id: 'BA', item_text: 'BA' },
      { item_id: 'MD', item_text: 'MD' },
      { item_id: 'Others', item_text: 'Others' }
    ];

    this.session_mode = [
      { item_id: 'f2f', item_text: 'Face To Face' },
      { item_id: 'video', item_text: 'Video' }
    ];

    this.languages = [
      { item_id: 'English', item_text: 'English' },
      { item_id: 'Hindi', item_text: 'Hindi' },
      { item_id: 'Bengali', item_text: 'Bengali' },
      { item_id: 'Telugu', item_text: 'Telugu' },
      { item_id: 'Marathi', item_text: 'Marathi' },
      { item_id: 'Tamil', item_text: 'Tamil' },
      { item_id: 'Urdu', item_text: 'Urdu' },
      { item_id: 'Kannada', item_text: 'Kannada' },
      { item_id: 'Gujarati', item_text: 'Gujarati' },
      { item_id: 'Odia', item_text: 'Odia' },
      { item_id: 'Punjabi', item_text: 'Punjabi' },
      { item_id: 'Malayalam', item_text: 'Malayalam' },
      { item_id: 'Assamese', item_text: 'Assamese' }
    ];

    this.speciality = [
      { item_id: 'ADHD', item_text: 'ADHD' },
      { item_id: 'Addictions', item_text: 'Addictions' },
      { item_id: 'Anxiety', item_text: 'Anxiety' },
      { item_id: 'Anger Management', item_text: 'Anger Management' },
      { item_id: 'Child and Adolescent Behaviour', item_text: 'Child and Adolescent Behaviour' },
      { item_id: 'Couples/Marital Therapy', item_text: 'Couples/Marital Therapy' },
      { item_id: 'Career Counselling', item_text: 'Career Counselling' },
      { item_id: 'Cognitive Behavioral Therapy', item_text: 'Cognitive Behavioral Therapy' },
      { item_id: 'Dyslexia', item_text: 'Dyslexia' },
      { item_id: 'Depression', item_text: 'Depression' },
      { item_id: 'Eating Disorder', item_text: 'Eating Disorder' },
      { item_id: 'Eating Disorder', item_text: 'Eating Disorder' },
      { item_id: 'Expat Adjustment Issues', item_text: 'Expat Adjustment Issues' },
      { item_id: 'Family Therapy', item_text: 'Family Therapy' },
      { item_id: 'Grief and Loss', item_text: 'Grief and Loss' },
      { item_id: 'Infidelity', item_text: 'Infidelity' },
      { item_id: 'Phobias', item_text: 'Phobias' },
      { item_id: 'Sexual/LGBT Issues', item_text: 'Sexual/LGBT Issues' },
      { item_id: 'Stress Management', item_text: 'Stress Management' },
      { item_id: 'Positive Parenting Program', item_text: 'Positive Parenting Program' },
      { item_id: 'Parenting', item_text: 'Parenting' },
      { item_id: 'OCD', item_text: 'OCD' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter
    };

    this.dropdownSettings1 = Object.assign({}, this.dropdownSettings1, { allowSearchFilter: this.ShowFilter });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  get f() { return this.addDocForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {
      //this.addDocForm.controls['photo'].setValue(this.selectedfile ? this.selectedfile : '');

      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );
    } else {
      this.addDocForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  fileUpload1(event) {

    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.selectedfile1[i].type === this.doc || this.selectedfile1[i].type === this.docx || this.selectedfile1[i].type === this.pdf) {
        this.addDocForm.get('certificates').clearValidators();
        return true;
      } else {

        this.addDocForm.controls.certificates.reset();
        this.toaster.showError('File Type', 'Only Documents are allowed');
        return false;
      }
    }
   // this.addDocForm.controls.certificates.setValue(this.selectedfile1 ? this.selectedfile1 : '');
  }



  // setConditionalValidation() {
  //   const own_space = this.addDocForm.get('own_space');
  //   const space_address = this.addDocForm.get('space_address');
  //
  //   this.addDocForm.get('session_mode').valueChanges
  //     .subscribe(session_mode => {
  //       if (session_mode === 'yes') {
  //         own_space.setValidators([Validators.required]);
  //         space_address.setValidators(null);
  //       }
  //     });
  //   this.addDocForm.get('own_space').valueChanges
  //     .subscribe(own_space => {
  //       if (own_space === 'yes') {
  //         space_address.setValidators([Validators.required]);
  //       }
  //     });
  //   own_space.updateValueAndValidity();
  //   space_address.updateValueAndValidity();
  // };


  toggleShow() {

    this.isShown = ! this.isShown;

  }

  toggleShow1() {

    this.isShown1 = ! this.isShown1;

  }


  onSubmit() {
    this.submitted = true;
    this.buttonenable = true;
    this.spinnerService.show();
    //console.log(this.addDocForm.controls.degree.value.toString());
    let degree1 = [];
    let languages1 = [];
    let speciality1 = [];
    let session_mode1 = [];

    console.log(this.findInvalidControls());
    // stop here if form is invalid
    if (this.addDocForm.invalid) {
      this.buttonenable = false;
      this.spinnerService.hide();
      return;
    }

    if (this.selectedfile1.length < 1){
      this.buttonenable = false;
      this.toaster.showError('Register', 'Certificates are requires');
      return;
    }

    this.addDocForm.controls.degree.value.forEach(function each(item) {
      degree1.push(item);
    });

    this.addDocForm.controls.language.value.forEach(function each(item1) {
      languages1.push(item1);
    });

    this.addDocForm.controls.speciality.value.forEach(function each(item2) {
      speciality1.push(item2);
    });
    this.addDocForm.controls.session_mode.value.forEach(function each(item3) {
      session_mode1.push(item3.item_id);
    });

    const addUserPayload = {
      users_name: this.addDocForm.controls.users_name.value,
      users_email: this.addDocForm.controls.users_email.value,
      users_code: this.addDocForm.controls.users_code.value,
      users_mobile: this.addDocForm.controls.users_mobile.value,
      users_city: this.addDocForm.controls.users_city.value,
      users_password: this.addDocForm.controls.users_password.value,
      users_status: 'false',
      users_usertype: 'doctor'
    };

    const addDoctorPayload = {
      degree: degree1.toString(),
      mental_health_prof: this.addDocForm.controls.mental_health_prof.value,
      experience: this.addDocForm.controls.experience.value,
      about: this.addDocForm.controls.about.value,
      gender: this.addDocForm.controls.gender.value,
      language: languages1.toString(),
      speciality: speciality1.toString(),
      session_mode: session_mode1.toString(),
      own_space: (this.addDocForm.controls.own_space.value)?this.addDocForm.controls.own_space.value:'N/A',
      space_address: (this.addDocForm.controls.space_address.value)?this.addDocForm.controls.space_address.value:'N/A',
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('users_email', addUserPayload.users_email);
    formdata.append('users_code', addUserPayload.users_code);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_password', addUserPayload.users_password);
    formdata.append('users_status', addUserPayload.users_status);
    formdata.append('users_usertype', addUserPayload.users_usertype);
    if (this.selectedfile !== null) {
      formdata.append('photo', this.selectedfile);
    }


    this.addUser(formdata, addDoctorPayload, this.selectedfile1);

  }

  addUser(payload, payload1, certificatefile) {
    this.userservice.addUser(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            const formdata = new FormData();
            formdata.append('docid', data.UserData._id);
            formdata.append('degree', payload1.degree);
            formdata.append('mental_health_prof', payload1.mental_health_prof);
            formdata.append('experience', payload1.experience);
            formdata.append('gender', payload1.gender);
            formdata.append('about', payload1.about);
            formdata.append('language', payload1.language);
            formdata.append('speciality', payload1.speciality);
            if(this.selectedfile1){
              const files: Array<File> = certificatefile;
              for (let i = 0; i < files.length; i++) {
                formdata.append('certificates', files[i], files[i].name);
              }
            }


            formdata.append('session_mode', payload1.session_mode);
            formdata.append('own_space', payload1.own_space);
            formdata.append('space_address', payload1.space_address);

            const scheduledata = {
              docid: data.UserData._id,
              day: 'Tue',
              date: '1991-06-29',
              start_time: '09:00',
              end_time: '09:00',
            };


            this.addDoctor(formdata,scheduledata);

          } else {
            this.toaster.showError('Add Doctor', data.ResponseMessage);
            this.msgcode = data.ResponseCode;
            this.buttonenable = false;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Doctor', error.error.ResponseMessage);
          this.msgcode = error.error.ResponseCode;
          this.buttonenable = false;
        });
  }

  addDoctor(payload,scheduledata) {
    this.doctorservice.addDoctor(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            fbq('track', 'CompleteRegistration');
            this.addEvent(scheduledata);

            //this.router.navigate(['/doctorlist']);
          } else {
            this.toaster.showError('Add Doctor', data.ResponseMessage);
            this.buttonenable = false;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Doctor', error.error.ResponseMessage);
          this.buttonenable = false;
        });
  }

login(loginPayload) {
  this.authenicationService.login(loginPayload)
    .subscribe(
      (data: any) => {
        if (data && data.ResponseCode === '200') {
          // console.log(data.userData);
          const decoded = jwt_decode(data.jwt);
          localStorage.setItem('userDetails', btoa(JSON.stringify(decoded)));
          this.authenicationService.userDetails();

          //this.toaster.showSuccess('Login', data.ResponseMessage);
          this.router.navigate([this.returnUrl]);
        } else {
          this.toaster.showError('Login', data.ResponseMessage);
        }
      },
      error => {
        this.submitted = false;
        this.toaster.showError('Login', error.error.ResponseMessage);
      });
}

  public findInvalidControls() {
    const invalid = [];
    const controls = this.addDocForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  addEvent(payload) {
    this.scheduleservice.addSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            const loginPayload = {
              users_email: this.addDocForm.controls.users_email.value,
              users_password: this.addDocForm.controls.users_password.value
            };
            this.login(loginPayload);

          } else {
            console.log(data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log(error.error.ResponseMessage);
        });
  }


}
